export default function DealershipContrast() {
  const rows = [
    {
      topic: 'Proof Required',
      dealer: 'DD-214, military ID, dependent ID — bring the paperwork or no deal',
      rockhound: 'Just tell us. We take your word for it.',
      dealerIcon: 'ri-file-list-3-line',
      rockhoundIcon: 'ri-chat-smile-2-line',
    },
    {
      topic: 'Their Real Motivation',
      dealer: 'They care that much about protecting their profit margin',
      rockhound: 'We just want to thank you for your service',
      dealerIcon: 'ri-money-dollar-circle-line',
      rockhoundIcon: 'ri-heart-fill',
    },
    {
      topic: 'The Process',
      dealer: 'Verify, document, approve — then maybe you get the discount',
      rockhound: 'Ask us about it. Done. Discount applied.',
      dealerIcon: 'ri-time-line',
      rockhoundIcon: 'ri-checkbox-circle-fill',
    },
    {
      topic: 'Who Qualifies',
      dealer: 'Only what they can verify with official documentation',
      rockhound: 'Active duty, veterans, reservists, spouses — if you served or support someone who did, you qualify',
      dealerIcon: 'ri-close-circle-line',
      rockhoundIcon: 'ri-shield-star-fill',
    },
    {
      topic: 'The Discount',
      dealer: 'A token gesture buried in fine print, often offset by markups elsewhere',
      rockhound: '$300 off the price — or donated to any charity you choose',
      dealerIcon: 'ri-subtract-line',
      rockhoundIcon: 'ri-gift-2-line',
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-slate-900 text-white relative overflow-hidden">
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Dealerships vs. Rockhound's Dog Tag Discount
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Most dealerships treat the dog tag discount like a favor. We treat it like a duty.
          </p>
        </div>

        {/* Column headers */}
        <div className="grid grid-cols-3 gap-4 mb-4 px-4">
          <div></div>
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-slate-700 rounded-lg px-4 py-2">
              <i className="ri-building-2-line text-slate-400"></i>
              <span className="font-bold text-slate-300 text-sm uppercase tracking-wide">Typical Dealership</span>
            </div>
          </div>
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-red-600 rounded-lg px-4 py-2">
              <i className="ri-shield-star-fill text-white"></i>
              <span className="font-bold text-white text-sm uppercase tracking-wide">Rockhound Auto</span>
            </div>
          </div>
        </div>

        {/* Comparison rows */}
        <div className="space-y-3">
          {rows.map((row, i) => (
            <div
              key={i}
              className="grid grid-cols-3 gap-4 bg-slate-800 rounded-xl overflow-hidden"
            >
              {/* Topic */}
              <div className="flex items-center px-6 py-5 bg-slate-800 border-r border-slate-700">
                <span className="font-semibold text-slate-300 text-sm">{row.topic}</span>
              </div>

              {/* Dealer */}
              <div className="flex items-start gap-3 px-6 py-5 bg-slate-800/60">
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${row.dealerIcon} text-slate-500 text-lg`}></i>
                </div>
                <p className="text-slate-400 text-sm leading-relaxed">{row.dealer}</p>
              </div>

              {/* Rockhound */}
              <div className="flex items-start gap-3 px-6 py-5 bg-red-950/30 border-l border-red-900/40">
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${row.rockhoundIcon} text-red-400 text-lg`}></i>
                </div>
                <p className="text-white text-sm leading-relaxed font-medium">{row.rockhound}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Quote */}
        <div className="mt-12 text-center">
          <blockquote className="text-2xl font-semibold text-yellow-400 italic max-w-3xl mx-auto">
            "Show us, tell us, or just ask — we don't care. We just want to thank you for your
            service."
          </blockquote>
          <p className="text-slate-400 mt-4">— Rockhound Auto</p>
        </div>
      </div>
    </section>
  );
}
